<script setup lang="ts">
interface Props {
  title: string;
  description?: string;
  actionLabel?: string;
}

const emit = defineEmits<{ action: [] }>();

withDefaults(defineProps<Props>(), { description: '', actionLabel: '' });
</script>

<template>
  <div class="flex flex-col items-center gap-3 p-xl text-center">
    <h4 class="text-body-medium font-medium text-text-primary">{{ title }}</h4>
    <p v-if="description" class="text-body-small text-text-secondary max-w-xs">
      {{ description }}
    </p>
    <button
      v-if="actionLabel"
      type="button"
      class="mt-2 px-md py-sm rounded-pill bg-bg-pill text-text-primary text-label-medium font-medium hover:opacity-90 transition-opacity"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>
